import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ContactInfoService} from "../../Services/contact-info/contact-info.service";
import {AppointmentsService} from "../../Services/appointments/appointments.service";
import {scrollToElement} from '../../helpers';

@Component({
  selector: 'app-cancel-demo',
  templateUrl: './cancel-demo.component.html',
  styleUrls: ['./cancel-demo.component.scss']
})
export class CancelDemoComponent implements OnInit {

  @Output() close = new EventEmitter();

  @Output() openCalendar = new EventEmitter();

  contactInfo: ContactInfoService;
  appointmentService: AppointmentsService;

  constructor(contactInfo: ContactInfoService, appointmentService: AppointmentsService) {
    this.contactInfo = contactInfo;
    this.appointmentService = appointmentService;
  }

  ngOnInit() {
  }

  cancel() {
    if ( window['appointmentID'] !== 0 ) {
      this.appointmentService.cancelDemoMobile().subscribe();
    } else {
      alert('You do not have an appointment yet.');
    }
  }

  reschedule() {
    // document.getElementById('acuitycal-container').scrollIntoView();
    scrollToElement('#acuitycal-container', -140);
    this.openCalendar.emit();
  }

  closePopup() {
    // document.getElementById('acuitycal-container').scrollIntoView();
    scrollToElement('#acuitycal-container', -140);
    this.close.emit();
  }

}



// WEBPACK FOOTER //
// /app/src/app/Components/cancel-demo/cancel-demo.component.ts